module.exports = __webpack_public_path__ + "static/media/sdg-intro.cfb2fcff.jpg";